import { debounce, isEmpty } from "lodash";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import moment from "moment";
import NoEvent from "./NoEvent";
import { formatWithCommas } from "../../Utils/Toast";
const SearchWrapper = ({ setSearch }) => {
  const [input, setInput] = useState("");
  const [list, setList] = useState([]);
  const navigate = useNavigate();
  const [series, setSeries] = useState([]);
  const debounceFn = useMemo(() => debounce(handleDebounceFn, 500), []);
  const [singleSelect, setSingleSelect] = useState([]);
  const groupMatchesBySeries = (matches, searchText = "") => {
    return matches.reduce((acc, match) => {
      const series = match?.seriesName || "Unknown Series";
      if (!acc[series]) acc[series] = [];
      acc[series].push(match);
      return acc;
    }, {});
  };
  const getData = async (value) => {
    if (isEmpty(value)) {
      setList([]);
    } else {
      const { status, data } = await apiGet(apiPath.searchEvent, {
        keyword: value,
      });
      if (data?.success) {
        setList(data?.results);
        setSeries(Object.entries(groupMatchesBySeries(data?.results, value)));
      }
    }
  };
  function handleDebounceFn(inputValue) {
    getData(inputValue);
  }

  function handleChange(event) {
    setInput(event.target.value);
    debounceFn(event.target.value);
  }

  const highlightText = (text) => {
    if (!input) return text;

    const regex = new RegExp(`(${input})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === input.toLowerCase() ? (
        <span key={index} className="text-back-600 font-bold">
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }

  const Events = ({ list }) => {
    return list?.map((res) => {
      return (
        <div
          onClick={() =>
            navigate(`/match-detail-velki/${res?.eventId}/${res?.marketId}`)
          }
          className="flex py-2 pl-4 pr-2 justify-between items-center"
        >
          <div className="flex-1">
            <div className="-mb-3px flex justify-start items-baseline">
              {res?.status == "in_play" ? (
                <div
                  data-v-ef8204d4
                  className="inline-flex items-center h-full mr-3px"
                  data-is-inplay-type="true"
                  data-is-today-type="false"
                  data-is-tomorrow-type="false"
                >
                  <div data-v-ef8204d4 className>
                    <div
                      data-v-ef8204d4
                      className="px-3px flex items-center justify-center bg-inPlay text-white font-bold text-8 leading-9px"
                    >
                      <span data-v-ef8204d4 className="mt-1px">
                        In-Play
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  data-v-ef8204d4
                  className="time-block flex items-center justify-center leading-9px"
                  data-is-today-type="true"
                  data-is-tomorrow-type="false"
                >
                  <span
                    data-v-ef8204d4
                    className="text-submenu py-px text-center text-8 px-2px pb-0"
                  >
                    {isDateToday(res?.eventDateTime)
                      ? "Today"
                      : moment(res?.eventDateTime).format("DD/MM")}{" "}
                    {moment(res?.eventDateTime).format("HH:MM")}
                  </span>
                </div>
              )}

              <div className="text-10 text-black-600 font-normal">
                <span className="pr-1">Matched</span>
                <span> {formatWithCommas(res?.totalMatched)}</span>
              </div>
            </div>
            <div>
              <div className="text-13 leading-17px">
                <span>{highlightText(res?.eventName)}</span>
              </div>
            </div>
          </div>
          <div className="flex justify-end items-center">
            <i className="icon-arrow-left transform rotate-180 text-12 text-black-500" />
          </div>
        </div>
      );
    });
  };
  return (
    <section
      className="search fixed top-40px w-full h-full-with-header-footer z-20 bg-black-100 overflow-hidden"
      style={{}}
    >
      <header className="sticky top-0 z-10">
        <div className="h-12 p-3 bg-secondary text-global-font-on-dark text-14 flex items-center justify-center">
          <input
            id="search"
            onChange={(e) => handleChange(e)}
            value={input}
            name="search"
            autoComplete="true"
            type="string"
            style={{background:'black'}}
            className="effect-20 relative w-full h-40px px-2 z-10 bg-white bg-opacity-0 caret-primary"
            placeholder="Search teams, competitions, and more..."
          />
          <span
            onClick={() => setSearch(false)}
            className="icon-close text-14"
          />
        </div>
      </header>

      <div id="searchContainer" className="h-full pb-82px overflow-y-scroll">
        {isEmpty(singleSelect) ? (
          <div>
            {series?.length > 0 && !isEmpty(input) && (
              <section className="pt-2 px-4">
                <div className="py-2 pl-3 text-15 font-bold">Competitions</div>
                <div className="bg-white rounded-xl text-black text-15 leading-tight divide-y divide-black-300">
                  {series?.map((res) => {
                    return (
                      <div
                        onClick={() =>
                          setSingleSelect({ title: res[0], list: res[1] })
                        }
                        className="flex py-2 pl-4 pr-2 justify-between items-center"
                      >
                        <div className="w-310px items-center break-all">
                          <div className="py-2">{highlightText(res[0])}</div>
                        </div>
                        <span className="icon-arrow-left transform rotate-180 text-12 text-black-500" />
                      </div>
                    );
                  })}
                </div>
              </section>
            )}
            {list?.length > 0 && !isEmpty(input) ? (
              <section className="py-11px px-4">
                <div className="pb-2 pl-3 text-15 font-bold">Event</div>
                <div className="bg-white rounded-xl text-black text-15 leading-tight divide-y divide-black-300">
                  <Events list={list} />
                </div>
              </section>
            ) : (
              <NoEvent />
            )}
          </div>
        ) : (
          <section className="py-11px px-4">
            <div className="bg-white rounded-xl text-black text-15 leading-tight divide-y divide-black-300">
              <div className="flex py-4 pl-4 pr-2 mb-16px items-center">
                <div
                  onClick={() => setSingleSelect({})}
                  className="pr-2 border-r border-r-black-300 text-black-500"
                >
                  <span className="pr-2 icon-arrow-left text-12" />
                  <span className="text-15">Back</span>
                </div>
                <span className="pl-4 text-15 truncate">
                  {" "}
                  {singleSelect?.title}
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl text-black text-15 leading-tight divide-y divide-black-300">
              <Events list={singleSelect?.list} />
            </div>
          </section>
        )}
      </div>
    </section>
  );
};

export default SearchWrapper;
